"use strict";export const openOverlay=async(e,n,i,r)=>{if(!1)var t;const{Overlay:o}=await import("@spectrum-web-components/overlay/src/overlay.js");return o.open(e,n,i,r)};
//# sourceMappingURL=loader.js.map
